module.exports = __webpack_public_path__ + "static/soc2-2f87fa64b882f2867a3a63061b642e64.png";